module.exports = __webpack_public_path__ + "img/ic-eye-close.885f1452.svg";